import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { StoreSpecificConfigService } from '@scalefast/config-angular';

export function dotPathCanActivateGuard(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
  const storeSpecificConfigService = inject(StoreSpecificConfigService);
  const path = route.routeConfig?.path ?? '';
  const dotPathsEnabled = storeSpecificConfigService.get().dotPathsEnabled;
  if (dotPathsEnabled) {
    return true;
  }
  const isDotPath = path?.startsWith('.');
  return !isDotPath;
}
